import { render } from "./Itpatrut.vue?vue&type=template&id=317948c4&scoped=true"
import script from "./Itpatrut.vue?vue&type=script&lang=js"
export * from "./Itpatrut.vue?vue&type=script&lang=js"

import "./Itpatrut.vue?vue&type=style&index=0&id=317948c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317948c4"]])

export default __exports__